<template lang="html">
<div style="display: inline">
  <span class="col-12" style="padding-left: 0; display: inline-block">
    <slot name="label"></slot>
  </span>
  <div>
  <select v-model="selectedValue" :id="id" :multiple="multiple" v-bind:class="className" :disabled="disabled" :data-placeholder="placeholder">
    <option></option>
    <template v-for="(key,value) in options">
     <optgroup v-if="Array.isArray(key) === true" :label="value">
        <option v-for="option in key" :value="option.value" :disabled="option.disabled === true">{{option.text}}</option>
      </optgroup>
    </template>
    <option v-for="option in options" :value="option.value" :disabled="option.disabled === true">
      {{option.text}}
    </option>
  </select>
</div>
</div>
</template>

<script>
import $ from 'jquery'
import 'chosen-js'
export default {
  props: {
    'value': [Number, String, Boolean, Array],
    'id': String,
    'options': {},
    'placeholder': String,
    'className': {
      type: String,
      default: 'chosen-select col-12'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    allowSingleDeselect: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    element: function() {
      return $('#' + this.id)
    },
    selectedValue: {
      get: function() {
        return this.value
      },
      set: function(value) {

      }
    }
  },
  mounted: function() {
    this.element.chosen({
      search_contains: true,
      allow_single_deselect: this.allowSingleDeselect,
      width: '100%'
    })
    this.element
      .on('change', (event, option) => {
        // console.log(this.element.val())
        this.$emit('input',
          this.element.val()
        )
      })
  },
  methods: {
    updateChosen() {
      this.element
        .trigger('chosen:updated')
    }
  },
  watch: {
    options: function() {
      this.updateChosen()
    },
    value: function() {
      this.selectedValue = this.value
    }
  },
  updated: function() {
    this.updateChosen()
  }
}
</script>

<style lang="css">
@import '@/../../../node_modules/chosen-js/chosen.css'
</style>

<style lang="css">
.chosen-container .chosen-results li.active-result {
  width: 100%;
}
</style>
